/**
 * The words of the install suggestion, said in three places: the card on
 * Home, the row in the profile sheet and the row in Settings. Safari on
 * iPhone and iPad has no install prompt, so there the steps are written out
 * and shown in the shell's `InstallSheet`.
 */
export const INSTALL_TITLE = 'Install Interlock';

export const INSTALL_DETAIL = 'Play from your home screen, even offline.';

export const IOS_INSTALL_DETAIL = 'Add it to your home screen from the Share menu.';

export const IOS_INSTALL_SHEET_TITLE = 'Install on iPhone or iPad';

export const IOS_INSTALL_INTRO = 'Safari installs a game from its Share menu.';

export const IOS_INSTALL_STEPS: readonly string[] = [
  'Tap Share in the toolbar',
  'Choose Add to Home Screen',
  'Tap Add',
];
